import { object as yupObject, string as yupString } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TranslationMessage from './transMessage'

export interface IProfessionInfoFormInput {
    primary_specialty: string;
    national_provider_id: string;
    practice_month: string;
    practice_year: string;
    preffered_communication?: string;
}

const formDefaults: IProfessionInfoFormInput = {
    primary_specialty: '',
    national_provider_id: '',
    practice_month: '',
    practice_year: '',
    preffered_communication: ''
};

const schema = (t: any) => yupObject({
    primary_specialty: yupString()
        .nullable()
        .required(t(TranslationMessage.ERROR_PRIMARY_SPECIALTY)),
    national_provider_id: yupString()
        .required(t(TranslationMessage.ERROR_REQUIRED_NPI))
        .matches(/^\d{10}$/, t(TranslationMessage.ERROR_INVALID_NPI)),
    preffered_communication: yupString()
        .nullable()
        .required(t(TranslationMessage.ERROR_COMMUNICATION_TYPE)),
});

const formSchemaResolver = (t: any) => yupResolver(schema(t));

export {
    formDefaults,
    formSchemaResolver
}